import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$accruePointsWithCoupons',
  initialState: false,
  reducers: {
    setAccruePointsWithCoupons(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setAccruePointsWithCoupons } = slice.actions;

export default slice.reducer;
